<style>
  :host {
    --bright-blue: oklch(51.01% 0.274 263.83);
    --electric-violet: oklch(53.18% 0.28 296.97);
    --french-violet: oklch(47.66% 0.246 305.88);
    --vivid-pink: oklch(69.02% 0.277 332.77);
    --hot-red: oklch(61.42% 0.238 15.34);
    --orange-red: oklch(63.32% 0.24 31.68);

    --gray-900: oklch(19.37% 0.006 300.98);
    --gray-700: oklch(36.98% 0.014 302.71);
    --gray-400: oklch(70.9% 0.015 304.04);

    --red-to-pink-to-purple-vertical-gradient: linear-gradient(
      180deg,
      var(--orange-red) 0%,
      var(--vivid-pink) 50%,
      var(--electric-violet) 100%
    );

    --red-to-pink-to-purple-horizontal-gradient: linear-gradient(
      90deg,
      var(--orange-red) 0%,
      var(--vivid-pink) 50%,
      var(--electric-violet) 100%
    );

    --pill-accent: var(--bright-blue);

    font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
      "Segoe UI Symbol";
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    /* Layout: fix .main to fill remaining viewport below navbar, no scroll, center content */
    html, body {
      height: 100%;
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }
    body {
      min-height: 100vh;
      font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
        Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
        "Segoe UI Symbol";
      background: #f8f9fa;
      overflow-x: hidden;
    }
    .top-strip {
      height: 15px;
      background: #021d7f;
      margin: 0;
      padding: 0;
    }
    .navbar {
      max-width: 98vw;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: white;
      height: 60px;
      padding: 1rem 1rem 1rem 2vw;
      box-sizing: border-box;
      border-bottom: 1px solid #e9ecef;
    }
    .navbar-left {
      display: flex;
      align-items: center;
    }
    .navbar-logo {
      height: 40px;
      width: auto;
      display: flex;
      align-items: center;
    }
    .navbar-center {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      font-size: 1.4rem;
      font-weight: 600;
      color: #021d7f;
      letter-spacing: 1px;
    }
    .navbar-right {
      display: flex;
      align-items: center;
      gap: 1.5rem;
      padding-right: 0.5rem;
    }
    .navbar-user {
      font-size: 0.9rem;
      color: #021d7f;
      font-weight: 500;
      white-space: nowrap;
    }
    .navbar-logout {
      background: #e53935;
      color: white;
      border: none;
      border-radius: 6px;
      padding: 0.5rem 1.2rem;
      font-size: 0.9rem;
      cursor: pointer;
      white-space: nowrap;
      transition: background-color 0.2s;
    }
    .navbar-logout:hover {
      background: #d32f2f;
    }
    .main {
      margin-top: 5px;
      min-height: calc(100vh - 75px);
      padding: 0 2rem;
      background: #f8f9fa;
    }
  }
</style>

<ng-container *ngIf="isReady; else loading">
<div class="top-strip"></div>
<nav class="navbar">
  <div class="navbar-left">
    <img src="/tenant-logo.png" alt="Logo" class="navbar-logo" />
    <app-navbar-nav></app-navbar-nav>
  </div>
  <div class="navbar-center">Multiplexor Portal</div>
  <div class="navbar-right">
    <app-navbar-user></app-navbar-user>
  </div>
</nav>

<main class="main">
  <router-outlet></router-outlet>
</main>
<footer class="footer">
  <span>© 2025-2026 Whittle Group, Inc. All Rights Reserved.</span>
  <a href="/privacy-policy" class="footer-link">Privacy Policy</a>
</footer>
</ng-container>

<ng-template #loading>
  <div class="loading-container" role="status" aria-label="Loading">
    <p-progressSpinner strokeWidth="4" fill="transparent" animationDuration="1s" [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
    <span class="visually-hidden">Loading, please wait</span>
  </div>
</ng-template>

